import { SET_STYLES } from '../../utils/constants'

// eslint-disable-next-line import/prefer-default-export
export const setStyles = (payload) => ({ type: SET_STYLES, payload })
